export enum TooltipDirection {
    LEFT = 'left',
    RIGHT = 'right',
    BOTTOM = 'bottom',
    UP = 'up'
}

export enum AlignMode {
    CENTER_CENTER = 'center_center',
    CENTER_BOTTOM = 'center_bottom'
}

export class ErrorToolTip {
    private static tooltipInstance: ErrorToolTip;
    private tooltipElement: JQuery;
    private alignMode: AlignMode = AlignMode.CENTER_CENTER;
    private lastTarget: JQuery; // remember for resize listener
    private lastDirection: TooltipDirection;
    private tooltipClass = 'error_tooltip';


    private constructor() {
        const tooltipElement = $('.error_tooltip');

        if (tooltipElement.length === 0) {
            throw new Error('tooltipNotPlaced');
        }

        $(window).on('resize', this.onResize);
        this.tooltipElement = tooltipElement;
    }

    public static getTooltipElement(): ErrorToolTip {
        if (typeof ErrorToolTip.tooltipInstance === 'undefined') {
            ErrorToolTip.tooltipInstance = new ErrorToolTip();
        }

        return ErrorToolTip.tooltipInstance;
    }


    public setTooltipElement(tooltip: JQuery) {
        this.tooltipElement = tooltip;
    }


    public getThemedCopy(theme: string) {
        const themedTooltip = new ErrorToolTip();
        themedTooltip.setTheme(theme);
        return themedTooltip;
    }

    public setMessage(msg: string) {
        if (this.tooltipClass === 'error_tooltip' || this.tooltipClass === 'error-tooltip') {
            this.tooltipElement.html(msg);
        }

        if (this.tooltipClass === 'tt-black') {
            this.tooltipElement.find('.tt-black__text').html(msg);
        }
    }

    public showTooltipElement = (targetElement: JQuery, direction: TooltipDirection, msg: string, addTermsClass?: boolean) => {
        if (typeof direction === 'undefined') {
            direction = TooltipDirection.LEFT;
        }

        if (typeof targetElement === 'undefined' || !targetElement.length) {
            throw new Error('arg `from` empty');
        }

        this.lastTarget = targetElement;
        this.lastDirection = direction;

        this.tooltipElement.removeClass(`${this.tooltipClass}_direction_${TooltipDirection.LEFT} ${this.tooltipClass}_direction_${TooltipDirection.RIGHT} ${this.tooltipClass}_direction_${TooltipDirection.BOTTOM} ${this.tooltipClass}_direction_${TooltipDirection.UP} terms`);
        this.tooltipElement.addClass(`${this.tooltipClass}_direction_${direction}`);

        if (addTermsClass) {
            this.tooltipElement.addClass('terms');
        }

        this.setMessage(msg);

        switch (direction) {
            case TooltipDirection.RIGHT:
                this.placeTooltipLeft(targetElement);
                break;
            case TooltipDirection.BOTTOM:
                this.placeTooltipBottom(targetElement);
                break;
            case TooltipDirection.UP:
                this.placeTooltipUp(targetElement);
                break;
            case TooltipDirection.LEFT:
                this.placeTooltipRight(targetElement);
                break;
        }

        this.tooltipElement.show();
    };

    public moveTooltipElement = () => {
        const direction = this.lastDirection;

        switch (direction) {
            case TooltipDirection.RIGHT:
                this.placeTooltipLeft(this.lastTarget);
                break;
            case TooltipDirection.BOTTOM:
                this.placeTooltipBottom(this.lastTarget);
                break;
            case TooltipDirection.UP:
                this.placeTooltipUp(this.lastTarget);
                break;
            case TooltipDirection.LEFT:
                this.placeTooltipRight(this.lastTarget);
                break;
        }
    };

    public setAlignMode(mode: AlignMode) {
        this.alignMode = mode;
    }

    public hide() {
        // this.tooltipElement.hide();
        $('.error_tooltip,.tt-black').hide();
    }

    private setTheme(theme: string) {
        this.tooltipClass = theme;
        this.tooltipElement = $(`.${this.tooltipClass}`);
    }

    private onResize = () => {
        if (this.lastTarget && this.lastTarget.length && this.tooltipElement.is(':visible')) {
            this.moveTooltipElement();
        }
    };

    private placeTooltipRight(targetElement: JQuery) {
        const fromOffset = targetElement.offset();
        const errorOuterHeight = this.tooltipElement.outerHeight();
        const targetHeight = targetElement.outerHeight();
        const targetWidth = targetElement.outerWidth();

        if (fromOffset === undefined ||
            targetHeight === undefined ||
            targetWidth === undefined ||
            errorOuterHeight === undefined
        ) {
            throw new Error('Cannot calculate tooltip position');
        }

        if (this.alignMode === AlignMode.CENTER_CENTER) {
            this.tooltipElement.css({
                position: 'absolute',
                top: fromOffset.top + ((targetHeight - errorOuterHeight) / 2),
                left: fromOffset.left + targetWidth + 10
            });
        }

        if (this.alignMode === AlignMode.CENTER_BOTTOM) {
            this.tooltipElement.css({
                position: 'absolute',
                top: fromOffset.top - ((errorOuterHeight - targetHeight) + (targetHeight / 2)),
                left: fromOffset.left + targetWidth + 10
            });
        }
    }

    private placeTooltipLeft(targetElement: JQuery) {
        const fromOffset = targetElement.offset();
        const errorOuterHeight = this.tooltipElement.outerHeight();
        const targetHeight = targetElement.outerHeight();
        const targetWidth = targetElement.outerWidth();

        if (fromOffset === undefined ||
            targetHeight === undefined ||
            targetWidth === undefined ||
            errorOuterHeight === undefined
        ) {
            throw new Error('Cannot calculate tooltip position');
        }

        if (this.alignMode === AlignMode.CENTER_CENTER) {
            this.tooltipElement.css({
                position: 'absolute',
                top: fromOffset.top - ((errorOuterHeight - targetHeight) / 2),
                left: fromOffset.left - (targetWidth + 10)
            });
        }

        if (this.alignMode === AlignMode.CENTER_BOTTOM) {
            this.tooltipElement.css({
                position: 'absolute',
                top: fromOffset.top - (targetHeight / 2),
                left: fromOffset.left - (targetWidth + 10)
            });
        }
    }

    private placeTooltipBottom(targetElement: JQuery) {
        const fromOffset = targetElement.offset();
        const targetWidth = targetElement.outerWidth();
        const outerWidth = this.tooltipElement.outerWidth();
        const errorOuterHeight = this.tooltipElement.outerHeight();

        if (fromOffset === undefined ||
            targetWidth === undefined ||
            outerWidth === undefined ||
            errorOuterHeight === undefined
        ) {
            throw new Error('Cannot calculate tooltip position');
        }

        let left = (fromOffset.left + targetWidth / 2) - (outerWidth / 2);

        if (left <= 0) {
            left = 10;
        }

        this.tooltipElement.css({
            position: 'absolute',
            top: fromOffset.top - errorOuterHeight - 10,
            left: left
        });
    }

    private placeTooltipUp(targetElement: JQuery) {
        const targetOffset = targetElement.offset();
        const targetWidth = targetElement.outerWidth();
        const outerWidth = this.tooltipElement.outerWidth();
        const outerHeight = this.tooltipElement.outerHeight();

        if (targetOffset === undefined ||
            targetWidth === undefined ||
            outerWidth === undefined ||
            outerHeight === undefined
        ) {
            throw new Error('Cannot calculate tooltip position');
        }
        let left = (targetOffset.left + targetWidth / 2) - (outerWidth / 2);

        if (left <= 0) {
            left = 10;
        }

        const top = targetOffset.top + outerHeight + 10;
        this.tooltipElement.css({
            position: 'absolute',
            top: top,
            left: left
        });
    }
}
